import React from 'react';

import {
  Box,
  Link,
  Stack,
  Image,
  Center,
  HStack,
  Flex,
  Text,
} from '@chakra-ui/react';

import { HelpCount } from 'components/DataDisplay/Utils/HelpCount';
import { HelpHeader } from 'components/DataDisplay/Utils/HelpHeader';

import { customTheme } from '../../../../../../../../../../../theme';

import gitlab_1 from './GitLab1.png';
import gitlab_2 from './GitLab2.png';
import gitlab_3 from './GitLab3.png';
import gitlab_4 from './GitLab4.png';

interface Props {
  onClose: () => void;
}

export const GitLabTokenHelp = (props: Props) => {
  const { onClose } = props;

  const renderImage = (src, alt) => (
    <Center>
      <Box
        border="1px solid"
        borderRadius={0}
        borderColor={customTheme.colors.gray['200']}
      >
        <Image src={src} w="full" fit="cover" alt={alt} />
      </Box>
    </Center>
  );

  return (
    <Stack h="full">
      <HelpHeader>Get GitLab Access Token</HelpHeader>
      <Stack px={4} spacing={6}>
        <HStack align={'start'}>
          <HelpCount count={1} />
          <Box>
            Log in to{' '}
            <Link
              color="primary"
              href="https://gitlab.com/users/sign_in"
              isExternal
            >
              GitLab
            </Link>
            .
          </Box>
        </HStack>
        <HStack align={'start'}>
          <HelpCount count={2} />
          <Stack spacing={4}>
            <Box>Go to the group you want Ariksa to monitor</Box>
            {renderImage(gitlab_1, 'gitlab_1')}
            {renderImage(gitlab_2, 'gitlab_2')}
          </Stack>
        </HStack>
        <HStack align={'start'}>
          <HelpCount count={3} />
          <Stack spacing={4}>
            <Text>
              Go to Settings {'->'} Access Tokens and click on Add new Token
              button. Choose role as <Text as="b">Owner</Text> (needed to read
              group security settings, tokens and CI/CD variables; the token
              stays read-only), select only the <Text as="b">read_api</Text> and{' '}
              <Text as="b">read_repository</Text> scopes (read_repository lets
              Ariksa scan repository contents), set an expiry of 90 days or
              less, and create the token. A group token covers every project in
              the group.
            </Text>
            {renderImage(gitlab_3, 'gitlab_3')}
            {renderImage(gitlab_4, 'gitlab_4')}
          </Stack>
        </HStack>
        <HStack align={'start'}>
          <HelpCount count={4} />
          <Stack spacing={4}>
            <Box>Copy and save the created token.</Box>
          </Stack>
        </HStack>
      </Stack>
    </Stack>
  );
};
